import { Challenge } from '@/features/journeys'

export const hasIntro = (challenge: Challenge) => {
  try {
    if (typeof challenge.intro !== 'string' || !challenge.intro.trim())
      return false

    const parser = new DOMParser()
    const doc = parser.parseFromString(challenge.intro, 'text/html')

    const text = doc.body.textContent.replace(/\s+/g, '')

    return text.length > 0
  } catch (error) {
    return (
      !!challenge?.intro && !!challenge.intro.replace(/<\/?p>|<br\s*\/?>/g, '')
    )
  }
}
